import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SidebarService {
	private minimizedSubject = new BehaviorSubject<boolean>(localStorage.getItem('sidebarMinimized') === 'true');
	minimized$ = this.minimizedSubject.asObservable();

	toggleMinimized() {
		const minimized = !this.minimizedSubject.value;
		this.minimizedSubject.next(minimized);
		localStorage.setItem('sidebarMinimized', minimized.toString());
	}
}
